import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import dragStart from '@mailobj-browser/front/js/events/types/dragStart.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onDragStart = object(listener, {
  type: dragStart,
  task: (
    body,
    event
  ) => {
    const { dataTransfer, target } = event
    const { ownerDocument } = body
    const { defaultView } = ownerDocument
    const { Text } = defaultView
    
    if (target instanceof Text) {
      const selection = document.getSelection()
      const { items } = dataTransfer
      
      items.clear()
      items.add(`${selection}`, 'text/plain')
      
      return
    }
    
    if (!target.hasAttribute?.('draggable')) {
      preventDefault(event)
    }
  }
})

export default body => {
  const { ownerDocument } = body
  
  if (!ownerDocument.contains(body)) {
    return
  }
  
  onDragStart.listen(body)
}
